/**
 * Resolves the user-facing "Control" label for an assessment finding row.
 *
 * For Infrastructure Security findings (source_type === 'infrastructure_security'),
 * the friendly Infrastructure Security control title is shown via
 * resolveInfrastructureControlDisplay() — never the raw control_key, and
 * never a generic domain.
 *
 * For all other findings (questionnaire-driven), the existing control_code
 * is returned unchanged.
 *
 * Fallback order for infrastructure findings:
 *   1. infrastructureControlMetadata title (resolveInfrastructureControlDisplay)
 *   2. humanized infrastructure_control_key (same helper does this for unknown keys)
 *   3. control_code
 *   4. "—"
 */
import { resolveInfrastructureControlDisplay } from "@/configs/controlGuidance/infrastructureControlMetadata";

export interface FindingControlLabelInput {
  source_type?: string | null;
  source_key?: string | null;
  // Some RPCs surface infrastructure_control_key directly instead of source_key.
  infrastructure_control_key?: string | null;
  control_code?: string | null;
}

export function resolveFindingControlLabel(f: FindingControlLabelInput): string {
  const infraKey = f.source_key || f.infrastructure_control_key || null;
  const isInfra = f.source_type === "infrastructure_security" || !!infraKey;

  if (isInfra && infraKey) {
    const { title } = resolveInfrastructureControlDisplay(infraKey);
    if (title && title.trim()) return title;
  }

  const cc = (f.control_code ?? "").trim();
  return cc || "—";
}
